"use client"

import { useState, useEffect } from "react"
import { useAuth } from "../../../contexts/AuthContext"

const CopyIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.98 0-3.6 1.64-3.6 3.6v2.25H5.25a2.25 2.25 0 0 0-2.25 2.25v6.75A2.25 2.25 0 0 0 5.25 19.5h6.75a2.25 2.25 0 0 0 2.25-2.25v-1.35M15.666 3.888l2.334 2.334M15.666 3.888A2.25 2.25 0 0 1 18 6.222l2.334 2.334M18 6.222v6.75a2.25 2.25 0 0 1-2.25 2.25h-6.75m6.75-9v-1.5a2.25 2.25 0 0 0-2.25-2.25H9a2.25 2.25 0 0 0-2.25 2.25v1.5m6.75 0V9a2.25 2.25 0 0 0-2.25-2.25H9A2.25 2.25 0 0 0 6.75 9v.75"
    />
  </svg>
)

const CheckIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
  </svg>
)

const PlayIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
    />
  </svg>
)

const DocumentIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
    />
  </svg>
)

const ImageIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2.25 15.75 5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
    />
  </svg>
)

const VideoIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15.75 10.5 4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
    />
  </svg>
)

const Apikey = () => {
  const {
    user,
    getUserApiKey,
    regenerateApiKey,
    getUserTemplates,
    syncTemplates,
    getUserMedia,
    uploadMedia,
    sendCampaignMessage,
  } = useAuth()

  const [apiKey, setApiKey] = useState("")
  const [loading, setLoading] = useState(true)
  const [regenerating, setRegenerating] = useState(false)
  const [copiedStates, setCopiedStates] = useState({})
  const [activeTab, setActiveTab] = useState("overview")
  const [activeLanguage, setActiveLanguage] = useState("javascript")

  const [templates, setTemplates] = useState([])
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [mediaFiles, setMediaFiles] = useState([])
  const [loadingTemplates, setLoadingTemplates] = useState(false)
  const [loadingMedia, setLoadingMedia] = useState(false)
  const [syncingTemplates, setSyncingTemplates] = useState(false)

  const [testData, setTestData] = useState({
    to: "",
    templateName: "",
    language: "en",
    variables: {},
    mediaUrl: "",
    mediaId: "",
    messageType: "text",
  })
  const [testResult, setTestResult] = useState(null)
  const [testing, setTesting] = useState(false)

  useEffect(() => {
    loadApiKey()
    loadTemplates()
    loadMedia()
  }, [])

  const loadApiKey = async () => {
    try {
      const response = await getUserApiKey()
      if (response.success) {
        setApiKey(response.apiKey)
      }
    } catch (error) {
      console.error("Error loading API key:", error)
    } finally {
      setLoading(false)
    }
  }

  const loadTemplates = async () => {
    setLoadingTemplates(true)
    try {
      const response = await getUserTemplates()
      if (response.success) {
        setTemplates(response.templates || [])
      }
    } catch (error) {
      console.error("Error loading templates:", error)
    } finally {
      setLoadingTemplates(false)
    }
  }

  const loadMedia = async () => {
    setLoadingMedia(true)
    try {
      const response = await getUserMedia(1, 20)
      if (response.success) {
        setMediaFiles(response.data || [])
      }
    } catch (error) {
      console.error("Error loading media:", error)
    } finally {
      setLoadingMedia(false)
    }
  }

  const handleSyncTemplates = async () => {
    setSyncingTemplates(true)
    try {
      const response = await syncTemplates()
      if (response.success) {
        await loadTemplates()
        const syncedCount = response.stats?.synced || 0
        const updatedCount = response.stats?.updated || 0
        alert(`Templates synced successfully! ${syncedCount} new, ${updatedCount} updated`)
      } else {
        alert(`Error syncing templates: ${response.error}`)
      }
    } catch (error) {
      console.error("Error syncing templates:", error)
      alert("Error syncing templates")
    } finally {
      setSyncingTemplates(false)
    }
  }

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template)
    setTestData((prev) => ({
      ...prev,
      templateName: template.name,
      language: template.language || "en",
      variables: {},
      mediaUrl: "",
      mediaId: "",
    }))

    // Determine message type based on template components
    let messageType = "text"
    if (template.components) {
      const headerComponent = template.components.find((c) => c.type === "HEADER")
      if (headerComponent && headerComponent.format) {
        switch (headerComponent.format.toUpperCase()) {
          case "IMAGE":
            messageType = "text_with_image"
            break
          case "VIDEO":
            messageType = "text_with_video"
            break
          case "DOCUMENT":
            messageType = "text_with_document"
            break
        }
      }
    }

    setTestData((prev) => ({ ...prev, messageType }))
  }

  const handleMediaSelect = (media) => {
    setTestData((prev) => ({
      ...prev,
      mediaId: media.mediaId,
      mediaUrl: media.whatsappUrl || "",
    }))
  }

  const displayApiKey = (key) => {
    if (!key) return "Loading..."
    if (key.length <= 10) return key
    const hiddenPart = "*".repeat(key.length - 10)
    return `${key.substring(0, 10)}${hiddenPart}`
  }

  const handleRegenerateApiKey = async () => {
    if (!window.confirm("Are you sure you want to regenerate your API key? This will invalidate your current key.")) {
      return
    }

    setRegenerating(true)
    try {
      const response = await regenerateApiKey()
      if (response.success) {
        setApiKey(response.apiKey)
      }
    } catch (error) {
      console.error("Error regenerating API key:", error)
    } finally {
      setRegenerating(false)
    }
  }

  const copyToClipboard = async (text, key) => {
    try {
      await navigator.clipboard.writeText(text)
      setCopiedStates((prev) => ({ ...prev, [key]: true }))
      setTimeout(() => {
        setCopiedStates((prev) => ({ ...prev, [key]: false }))
      }, 2000)
    } catch (error) {
      console.error("Failed to copy:", error)
    }
  }

  const handleTestMessage = async () => {
    if (!testData.to || !testData.templateName) {
      alert("Please fill in phone number and select a template")
      return
    }

    setTesting(true)
    try {
      const messagePayload = {
        to: testData.to,
        templateName: testData.templateName,
        language: testData.language,
        variables: testData.variables,
      }

      // Add media if selected
      if (testData.mediaId) {
        messagePayload.mediaId = testData.mediaId
      } else if (testData.mediaUrl) {
        messagePayload.mediaUrl = testData.mediaUrl
      }

      const response = await sendCampaignMessage(messagePayload)
      setTestResult(response)
    } catch (error) {
      setTestResult({
        success: false,
        error: "Network error occurred",
        details: error.message,
      })
    } finally {
      setTesting(false)
    }
  }

  const handleVariableChange = (index, value) => {
    setTestData((prev) => ({
      ...prev,
      variables: {
        ...prev.variables,
        [index]: value,
      },
    }))
  }

  const getTemplateVariables = () => {
    if (!selectedTemplate || !selectedTemplate.parameterAnalysis) return []
    return selectedTemplate.parameterAnalysis.bodyParameters || []
  }

  const codeExamples = {
    javascript: {
      sendMessage: `// Send WhatsApp Message
const response = await fetch('https://your-api-domain.com/api/campaigns/send-message', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': '${apiKey || "your-api-key"}'
  },
  body: JSON.stringify({
    to: '+1234567890',
    templateName: 'hello_world',
    language: 'en',
    variables: {
      '1': 'John Doe',
      '2': 'Welcome to our service'
    },
    mediaUrl: 'https://example.com/image.jpg' // Optional for media templates
  })
});

const result = await response.json();
console.log(result);`,
      createCampaign: `// Create Campaign
const response = await fetch('https://your-api-domain.com/api/campaigns/api/create', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-API-Key': '${apiKey || "your-api-key"}'
  },
  body: JSON.stringify({
    campaignName: 'My Campaign',
    templateName: 'hello_world',
    language: 'en',
    messageType: 'marketing',
    bodyVariables: [
      { index: 1, defaultValue: 'Customer Name' },
      { index: 2, defaultValue: 'Product Name' }
    ]
  })
});

const result = await response.json();
console.log(result);`,
      getTemplates: `// Get Templates
const response = await fetch('https://your-api-domain.com/api/templates/user', {
  method: 'GET',
  headers: {
    'Authorization': 'Bearer ${apiKey || "your-api-key"}'
  }
});

const templates = await response.json();
console.log(templates);`,
    },
    php: {
      sendMessage: `<?php
// Send WhatsApp Message
$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => 'https://your-api-domain.com/api/campaigns/send-message',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS => json_encode(array(
    'to' => '+1234567890',
    'templateName' => 'hello_world',
    'language' => 'en',
    'variables' => array(
      '1' => 'John Doe',
      '2' => 'Welcome to our service'
    ),
    'mediaUrl' => 'https://example.com/image.jpg'
  )),
  CURLOPT_HTTPHEADER => array(
    'Content-Type: application/json',
    'X-API-Key: ${apiKey || "your-api-key"}'
  ),
));

$response = curl_exec($curl);
curl_close($curl);

$result = json_decode($response, true);
print_r($result);
?>`,
      createCampaign: `<?php
// Create Campaign
$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => 'https://your-api-domain.com/api/campaigns/api/create',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS => json_encode(array(
    'campaignName' => 'My Campaign',
    'templateName' => 'hello_world',
    'language' => 'en',
    'messageType' => 'marketing',
    'bodyVariables' => array(
      array('index' => 1, 'defaultValue' => 'Customer Name'),
      array('index' => 2, 'defaultValue' => 'Product Name')
    )
  )),
  CURLOPT_HTTPHEADER => array(
    'Content-Type: application/json',
    'X-API-Key: ${apiKey || "your-api-key"}'
  ),
));

$response = curl_exec($curl);
curl_close($curl);

$result = json_decode($response, true);
print_r($result);
?>`,
      getTemplates: `<?php
// Get Templates
$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => 'https://your-api-domain.com/api/templates/user',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_HTTPHEADER => array(
    'Authorization: Bearer ${apiKey || "your-api-key"}'
  ),
));

$response = curl_exec($curl);
curl_close($curl);

$templates = json_decode($response, true);
print_r($templates);
?>`,
    },
    python: {
      sendMessage: `import requests
import json

# Send WhatsApp Message
url = "https://your-api-domain.com/api/campaigns/send-message"

payload = {
    "to": "+1234567890",
    "templateName": "hello_world",
    "language": "en",
    "variables": {
        "1": "John Doe",
        "2": "Welcome to our service"
    },
    "mediaUrl": "https://example.com/image.jpg"
}

headers = {
    "Content-Type": "application/json",
    "X-API-Key": "${apiKey || "your-api-key"}"
}

response = requests.post(url, data=json.dumps(payload), headers=headers)
result = response.json()
print(result)`,
      createCampaign: `import requests
import json

# Create Campaign
url = "https://your-api-domain.com/api/campaigns/api/create"

payload = {
    "campaignName": "My Campaign",
    "templateName": "hello_world",
    "language": "en",
    "messageType": "marketing",
    "bodyVariables": [
        {"index": 1, "defaultValue": "Customer Name"},
        {"index": 2, "defaultValue": "Product Name"}
    ]
}

headers = {
    "Content-Type": "application/json",
    "X-API-Key": "${apiKey || "your-api-key"}"
}

response = requests.post(url, data=json.dumps(payload), headers=headers)
result = response.json()
print(result)`,
      getTemplates: `import requests

# Get Templates
url = "https://your-api-domain.com/api/templates/user"

headers = {
    "Authorization": "Bearer ${apiKey || "your-api-key"}"
}

response = requests.get(url, headers=headers)
templates = response.json()
print(templates)`,
    },
    nodejs: {
      sendMessage: `const axios = require('axios');

// Send WhatsApp Message
const sendMessage = async () => {
  try {
    const response = await axios.post('https://your-api-domain.com/api/campaigns/send-message', {
      to: '+1234567890',
      templateName: 'hello_world',
      language: 'en',
      variables: {
        '1': 'John Doe',
        '2': 'Welcome to our service'
      },
      mediaUrl: 'https://example.com/image.jpg'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': '${apiKey || "your-api-key"}'
      }
    });
    
    console.log(response.data);
  } catch (error) {
    console.error('Error:', error.response?.data || error.message);
  }
};

sendMessage();`,
      createCampaign: `const axios = require('axios');

// Create Campaign
const createCampaign = async () => {
  try {
    const response = await axios.post('https://your-api-domain.com/api/campaigns/api/create', {
      campaignName: 'My Campaign',
      templateName: 'hello_world',
      language: 'en',
      messageType: 'marketing',
      bodyVariables: [
        { index: 1, defaultValue: 'Customer Name' },
        { index: 2, defaultValue: 'Product Name' }
      ]
    }, {
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': '${apiKey || "your-api-key"}'
      }
    });
    
    console.log(response.data);
  } catch (error) {
    console.error('Error:', error.response?.data || error.message);
  }
};

createCampaign();`,
      getTemplates: `const axios = require('axios');

// Get Templates
const getTemplates = async () => {
  try {
    const response = await axios.get('https://your-api-domain.com/api/templates/user', {
      headers: {
        'Authorization': 'Bearer ${apiKey || "your-api-key"}'
      }
    });
    
    console.log(response.data);
  } catch (error) {
    console.error('Error:', error.response?.data || error.message);
  }
};

getTemplates();`,
    },
  }

  const errorCodes = [
    {
      code: "MISSING_API_KEY",
      status: 400,
      description: "API key is required in headers",
      solution: "Include X-API-Key header with your API key",
    },
    {
      code: "INVALID_API_KEY",
      status: 401,
      description: "The provided API key is invalid or expired",
      solution: "Check your API key or regenerate a new one",
    },
    {
      code: "MISSING_RECIPIENT",
      status: 400,
      description: "Recipient phone number is required",
      solution: "Include 'to' field with valid phone number",
    },
    {
      code: "MISSING_TEMPLATE",
      status: 400,
      description: "Template name is required",
      solution: "Include 'templateName' field with valid template name",
    },
    {
      code: "TEMPLATE_NOT_FOUND",
      status: 404,
      description: "The specified template was not found",
      solution: "Check template name and ensure it exists in your account",
    },
    {
      code: "TEMPLATE_NOT_APPROVED",
      status: 400,
      description: "Template is not approved by WhatsApp",
      solution: "Wait for template approval or use an approved template",
    },
    {
      code: "INSUFFICIENT_BALANCE",
      status: 400,
      description: "Not enough credits to send message",
      solution: "Add more credits to your account",
    },
    {
      code: "INVALID_PHONE_NUMBER",
      status: 400,
      description: "Phone number format is invalid",
      solution: "Use international format: +1234567890",
    },
    {
      code: "WHATSAPP_API_ERROR",
      status: 500,
      description: "Error from WhatsApp Business API",
      solution: "Check WhatsApp API status or contact support",
    },
  ]

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading API documentation...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 bg-gradient-to-br from-green-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
              <div>
                <h1 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-green-700 to-blue-600 bg-clip-text text-transparent mb-2">
                  API Documentation
                </h1>
                <p className="text-gray-600 dark:text-gray-400 text-lg">
                  Integrate WhatsApp messaging into your applications
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar Navigation */}
          <div className="lg:col-span-1">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 sticky top-8">
              <nav className="space-y-2">
                {[
                  { id: "overview", label: "Overview", icon: DocumentIcon },
                  { id: "authentication", label: "Authentication", icon: DocumentIcon },
                  { id: "templates", label: "Templates", icon: DocumentIcon },
                  { id: "create-template", label: "Create Template", icon: DocumentIcon },
                  { id: "send-message", label: "Send Message", icon: DocumentIcon },
                  { id: "campaigns", label: "Campaigns", icon: DocumentIcon },
                  { id: "webhooks", label: "Webhooks", icon: DocumentIcon },
                  { id: "testing", label: "API Testing", icon: PlayIcon },
                  { id: "errors", label: "Error Codes", icon: DocumentIcon },
                ].map((item) => {
                  const isActive = activeTab === item.id
                  const buttonClass = isActive
                    ? "bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300"
                    : "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"

                  return (
                    <button
                      key={item.id}
                      onClick={() => setActiveTab(item.id)}
                      className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-left transition-colors ${buttonClass}`}
                    >
                      <item.icon className="w-4 h-4" />
                      <span className="text-sm font-medium">{item.label}</span>
                    </button>
                  )
                })}
              </nav>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
              {/* Overview Tab */}
              {activeTab === "overview" && (
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">API Overview</h2>
                  <div className="prose dark:prose-invert max-w-none">
                    <p className="text-gray-600 dark:text-gray-400 mb-6">
                      Our WhatsApp Business API allows you to send template messages, manage campaigns, and integrate
                      WhatsApp messaging into your applications. All API endpoints use REST architecture with JSON
                      payloads.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                      <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-4">
                        <h3 className="font-semibold text-green-800 dark:text-green-300 mb-2">Base URL</h3>
                        <code className="text-sm bg-white dark:bg-gray-800 px-2 py-1 rounded">
                          https://your-api-domain.com/api
                        </code>
                      </div>
                      <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
                        <h3 className="font-semibold text-blue-800 dark:text-blue-300 mb-2">Rate Limits</h3>
                        <p className="text-sm text-blue-700 dark:text-blue-300">1000 requests per hour</p>
                      </div>
                    </div>

                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                      Supported Message Types
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                      {[
                        { type: "Text", icon: DocumentIcon, description: "Plain text messages with variables" },
                        { type: "Image", icon: ImageIcon, description: "Text with image attachment" },
                        { type: "Video", icon: VideoIcon, description: "Text with video attachment" },
                        { type: "Document", icon: DocumentIcon, description: "Text with document attachment" },
                      ].map((messageType) => (
                        <div key={messageType.type} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 text-center">
                          <messageType.icon className="w-8 h-8 mx-auto mb-2 text-gray-600 dark:text-gray-400" />
                          <h4 className="font-medium text-gray-900 dark:text-white">{messageType.type}</h4>
                          <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">{messageType.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Authentication Tab */}
              {activeTab === "authentication" && (
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Authentication</h2>

                  <div className="mb-6">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Your API Key</h3>
                    <div className="flex items-center space-x-2 mb-4">
                      <input
                        type="text"
                        value={displayApiKey(apiKey)}
                        readOnly
                        className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white font-mono text-sm"
                      />
                      <button
                        onClick={() => copyToClipboard(apiKey, "apikey")}
                        className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 flex items-center space-x-2"
                      >
                        {copiedStates.apikey ? <CheckIcon className="w-4 h-4" /> : <CopyIcon className="w-4 h-4" />}
                        <span>{copiedStates.apikey ? "Copied!" : "Copy Full"}</span>
                      </button>
                    </div>
                    <button
                      onClick={handleRegenerateApiKey}
                      disabled={regenerating}
                      className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 disabled:opacity-50"
                    >
                      {regenerating ? "Regenerating..." : "Regenerate API Key"}
                    </button>
                  </div>

                  <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4 mb-6">
                    <h4 className="font-semibold text-yellow-800 dark:text-yellow-300 mb-2">⚠️ Security Notice</h4>
                    <p className="text-yellow-700 dark:text-yellow-300 text-sm">
                      Keep your API key secure and never expose it in client-side code. Use environment variables or
                      secure configuration management in production.
                    </p>
                  </div>

                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Authentication Methods</h3>
                  <div className="space-y-4">
                    <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                      <h4 className="font-medium text-gray-900 dark:text-white mb-2">Header Authentication</h4>
                      <pre className="bg-gray-800 text-green-400 p-3 rounded text-sm overflow-x-auto">
                        X-API-Key: {apiKey || "your-api-key"}
                      </pre>
                    </div>
                    <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                      <h4 className="font-medium text-gray-900 dark:text-white mb-2">Bearer Token (Alternative)</h4>
                      <pre className="bg-gray-800 text-green-400 p-3 rounded text-sm overflow-x-auto">
                        Authorization: Bearer {apiKey || "your-api-key"}
                      </pre>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "templates" && (
                <div className="p-6">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Templates</h2>
                    <button
                      onClick={handleSyncTemplates}
                      disabled={syncingTemplates}
                      className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center space-x-2"
                    >
                      <span>{syncingTemplates ? "Syncing..." : "Sync Templates"}</span>
                    </button>
                  </div>

                  {loadingTemplates ? (
                    <div className="text-center py-8">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600 mx-auto mb-4"></div>
                      <p className="text-gray-600 dark:text-gray-400">Loading templates...</p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {templates.map((template) => {
                        const isSelected = selectedTemplate?.templateId === template.templateId
                        const cardClass = isSelected
                          ? "border-green-500 bg-green-50 dark:bg-green-900/20"
                          : "border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600"

                        const statusClass =
                          template.status === "APPROVED"
                            ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                            : "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200"

                        return (
                          <div
                            key={template.templateId || template.id}
                            className={`border rounded-lg p-4 cursor-pointer transition-colors ${cardClass}`}
                            onClick={() => handleTemplateSelect(template)}
                          >
                            <div className="flex justify-between items-start mb-2">
                              <h3 className="font-semibold text-gray-900 dark:text-white">{template.name}</h3>
                              <span className={`px-2 py-1 rounded-full text-xs font-semibold ${statusClass}`}>
                                {template.status}
                              </span>
                            </div>
                            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                              Category: {template.category} | Language: {template.language}
                            </p>
                            {template.parameterAnalysis && (
                              <p className="text-xs text-gray-500 dark:text-gray-500">
                                Variables: {template.parameterAnalysis.bodyParameterCount || 0}
                                {template.parameterAnalysis.headerRequiresParameters && " + Header Media"}
                              </p>
                            )}
                          </div>
                        )
                      })}
                    </div>
                  )}

                  {templates.length === 0 && !loadingTemplates && (
                    <div className="text-center py-8">
                      <DocumentIcon className="w-12 h-12 mx-auto mb-4 text-gray-400" />
                      <p className="text-gray-600 dark:text-gray-400">
                        No templates found. Click "Sync Templates" to load your WhatsApp templates.
                      </p>
                    </div>
                  )}
                </div>
              )}

              {/* Create Template Tab */}
              {activeTab === "create-template" && (
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Create Template API</h2>
                  <div className="mb-6">
                    <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 mb-4">
                      <h3 className="font-semibold text-green-800 dark:text-green-300 mb-2">Endpoint</h3>
                      <code className="text-sm bg-white dark:bg-gray-800 px-2 py-1 rounded">
                        POST /api/templatecreate/create
                      </code>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Request Parameters</h3>
                    <div className="overflow-x-auto mb-6">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead className="bg-gray-50 dark:bg-gray-700">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Parameter</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Type</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Required</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">Description</th>
                          </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                          {[
                            { param: "name", type: "string", required: "Yes", desc: "Template name (lowercase and underscores only)" },
                            { param: "language", type: "string", required: "Yes", desc: "Language code (e.g., 'en', 'en_US')" },
                            { param: "category", type: "string", required: "Yes", desc: "MARKETING, UTILITY, or AUTHENTICATION" },
                            { param: "components", type: "array", required: "Yes", desc: "Array of component objects (HEADER, BODY, FOOTER, BUTTONS)" }
                          ].map((row) => (
                            <tr key={row.param}>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">{row.param}</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">{row.type}</td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm">
                                <span className={`px-2 py-1 rounded-full text-xs font-semibold ${row.required === "Yes" ? "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200" : "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200"}`}>{row.required}</span>
                              </td>
                              <td className="px-6 py-4 text-sm text-gray-500 dark:text-gray-400">{row.desc}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <div className="mt-8">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Media Template Creation Process</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                      When creating a template with media (Image, Video, Document), you must first upload the media to get a <code>header_handle</code>, and then pass that handle in the Create Template API payload.
                    </p>
                    
                    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-4">
                      <h4 className="font-semibold text-blue-800 dark:text-blue-300 mb-2">Step 1: Upload Media</h4>
                      <code className="text-sm bg-white dark:bg-gray-800 px-2 py-1 rounded">
                        POST /api/templatecreate/upload-media
                      </code>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mt-2 mb-2">Send a <code>multipart/form-data</code> request with your file in the <code>file</code> field. <b>Important:</b> Ensure you pass your API Key in the headers.</p>
                      <pre className="bg-gray-800 text-green-400 p-3 rounded text-xs overflow-x-auto">
{`// Example Response:
{
  "success": true,
  "message": "Media upload successfully",
  "header_handle": "4::dmlkZW8...ARZ"
}`}
                      </pre>
                    </div>

                    <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 mb-4">
                      <h4 className="font-semibold text-green-800 dark:text-green-300 mb-2">Step 2: Create Template</h4>
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">Call the Create Template API and use the <code>header_handle</code> in your components array:</p>
                      <pre className="bg-gray-800 text-green-400 p-3 rounded text-xs overflow-x-auto">
{`{
  "name": "promo_with_video",
  "language": "en",
  "category": "MARKETING",
  "components": [
    {
      "type": "HEADER",
      "format": "VIDEO",
      "example": {
        "header_handle": [ "YOUR_HEADER_HANDLE_HERE" ]
      }
    }
  ]
}`}
                      </pre>
                    </div>
                  </div>
                </div>
              )}

              {/* Webhooks Tab */}
              {activeTab === "webhooks" && (
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Webhooks</h2>
                  <p className="text-gray-600 dark:text-gray-400 mb-6">Configure endpoints to receive real-time updates for message statuses and incoming messages.</p>
                  
                  <div className="mb-8">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">1. Status Update Webhook</h3>
                    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-4">
                      <h4 className="font-semibold text-blue-800 dark:text-blue-300 mb-2">Your Server Receives (POST)</h4>
                      <code className="text-sm bg-white dark:bg-gray-800 px-2 py-1 rounded">/api/webhook/status</code>
                    </div>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">Receives delivery status updates (sent, delivered, read, failed) for messages you send.</p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">2. Incoming Messages Webhook</h3>
                    <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 mb-4">
                      <h4 className="font-semibold text-green-800 dark:text-green-300 mb-2">Your Server Receives (POST)</h4>
                      <code className="text-sm bg-white dark:bg-gray-800 px-2 py-1 rounded">/api/webhook/whatsapp/:number</code>
                    </div>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">Receives incoming text messages and media sent by your customers to your WhatsApp number.</p>
                  </div>
                </div>
              )}

              {/* Testing Tab */}
              {activeTab === "testing" && (
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">API Testing</h2>
                  <p className="text-gray-600 dark:text-gray-400 mb-6">
                    Test your API integration directly from this interface. Select a template and send test messages.
                  </p>

                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {/* Test Form */}
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Test Message</h3>
                      <div className="space-y-4">
                        {/* Template Selection */}
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Select Template *
                          </label>
                          <select
                            value={selectedTemplate?.templateId || ""}
                            onChange={(e) => {
                              const template = templates.find((t) => t.templateId === e.target.value)
                              if (template) handleTemplateSelect(template)
                            }}
                            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                          >
                            <option value="">Choose a template...</option>
                            {templates
                              .filter((t) => t.status === "APPROVED")
                              .map((template) => (
                                <option key={template.templateId} value={template.templateId}>
                                  {template.name} ({template.language})
                                </option>
                              ))}
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Phone Number *
                          </label>
                          <input
                            type="text"
                            placeholder="+1234567890"
                            value={testData.to}
                            onChange={(e) => setTestData((prev) => ({ ...prev, to: e.target.value }))}
                            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                          />
                        </div>

                        {getTemplateVariables().map((variable) => (
                          <div key={variable.index}>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                              {variable.name || `Variable ${variable.index}`}
                            </label>
                            <input
                              type="text"
                              placeholder={`Enter value for variable ${variable.index}`}
                              value={testData.variables[variable.index] || ""}
                              onChange={(e) => handleVariableChange(variable.index, e.target.value)}
                              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            />
                          </div>
                        ))}

                        {selectedTemplate?.parameterAnalysis?.headerRequiresParameters && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                              Media ({selectedTemplate.parameterAnalysis.headerType})
                            </label>
                            <div className="space-y-2">
                              <input
                                type="url"
                                placeholder="Media URL"
                                value={testData.mediaUrl}
                                onChange={(e) => setTestData((prev) => ({ ...prev, mediaUrl: e.target.value }))}
                                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                              />
                              <p className="text-xs text-gray-500">Or select from uploaded media:</p>
                              <div className="max-h-32 overflow-y-auto border border-gray-200 dark:border-gray-600 rounded">
                                {mediaFiles
                                  .filter((m) => m.fileType === selectedTemplate.parameterAnalysis.headerType)
                                  .map((media) => (
                                    <div
                                      key={media.mediaId}
                                      className="p-2 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-100 dark:border-gray-600 last:border-b-0"
                                      onClick={() => handleMediaSelect(media)}
                                    >
                                      <p className="text-sm font-medium">{media.fileName}</p>
                                      <p className="text-xs text-gray-500">
                                        {media.fileType} • {(media.fileSize / 1024).toFixed(1)}KB
                                      </p>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        )}

                        <button
                          onClick={handleTestMessage}
                          disabled={testing || !testData.to || !selectedTemplate}
                          className="w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 disabled:opacity-50 flex items-center justify-center space-x-2"
                        >
                          <PlayIcon className="w-4 h-4" />
                          <span>{testing ? "Sending..." : "Send Test Message"}</span>
                        </button>
                      </div>
                    </div>

                    {/* Test Result */}
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Test Result</h3>
                      {testResult ? (
                        <div
                          className={`rounded-lg p-4 ${
                            testResult.success
                              ? "bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800"
                              : "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800"
                          }`}
                        >
                          <div className="flex items-center space-x-2 mb-3">
                            <div
                              className={`w-3 h-3 rounded-full ${testResult.success ? "bg-green-500" : "bg-red-500"}`}
                            ></div>
                            <span
                              className={`font-medium ${
                                testResult.success
                                  ? "text-green-800 dark:text-green-300"
                                  : "text-red-800 dark:text-red-300"
                              }`}
                            >
                              {testResult.success ? "Success" : "Error"}
                            </span>
                          </div>
                          <pre className="bg-gray-900 text-green-400 p-3 rounded text-sm overflow-x-auto">
                            {JSON.stringify(testResult, null, 2)}
                          </pre>
                        </div>
                      ) : (
                        <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-8 text-center">
                          <PlayIcon className="w-12 h-12 mx-auto mb-4 text-gray-400" />
                          <p className="text-gray-600 dark:text-gray-400">
                            Select a template and fill in the form to send a test message.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Send Message Tab */}
              {activeTab === "send-message" && (
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Send WhatsApp Message</h2>

                  <div className="mb-6">
                    <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 mb-4">
                      <h3 className="font-semibold text-green-800 dark:text-green-300 mb-2">Endpoints</h3>
                      <div className="space-y-2">
                        <div>
                          <code className="text-sm bg-white dark:bg-gray-800 px-2 py-1 rounded">
                            POST /api/send-template
                          </code>
                          <p className="text-xs text-green-700 dark:text-green-400 mt-1">Primary endpoint for sending template messages to single or multiple numbers.</p>
                        </div>
                      </div>
                    </div>

                    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-4">
                      <h3 className="font-semibold text-blue-800 dark:text-blue-300 mb-2">Authentication</h3>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        All requests must include your API Key in the headers. You can pass it as:
                        <br/>
                        <code className="bg-white dark:bg-gray-800 px-1 rounded">x-api-key: YOUR_API_KEY</code> OR <code className="bg-white dark:bg-gray-800 px-1 rounded">Authorization: Bearer YOUR_API_KEY</code>
                      </p>
                    </div>

                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Request Parameters</h3>
                    <div className="overflow-x-auto mb-6">
                      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead className="bg-gray-50 dark:bg-gray-700">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                              Parameter
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                              Type
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                              Required
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                              Description
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                          {[
                            {
                              param: "to",
                              type: "string | array",
                              required: "Yes",
                              desc: "Single recipient phone number (e.g., '918530008530') or an array of numbers (e.g., ['918530008530', '919166344811'])",
                            },
                            {
                              param: "templateName",
                              type: "string",
                              required: "Yes",
                              desc: "WhatsApp approved template name",
                            },
                            {
                              param: "language",
                              type: "string",
                              required: "No",
                              desc: "Template language (default: 'en')",
                            },
                            {
                              param: "variables",
                              type: "object",
                              required: "No",
                              desc: "Template variables as key-value pairs",
                            },
                            {
                              param: "mediaUrl",
                              type: "string",
                              required: "No",
                              desc: "Media URL for image/video/document templates",
                            },
                            {
                              param: "mediaId",
                              type: "string",
                              required: "No",
                              desc: "WhatsApp media ID (alternative to mediaUrl)",
                            },
                          ].map((row) => {
                            const requiredClass =
                              row.required === "Yes"
                                ? "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                                : "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200"

                            return (
                              <tr key={row.param}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">
                                  {row.param}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                  {row.type}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm">
                                  <span className={`px-2 py-1 rounded-full text-xs font-semibold ${requiredClass}`}>
                                    {row.required}
                                  </span>
                                </td>
                                <td className="px-6 py-4 text-sm text-gray-500 dark:text-gray-400">{row.desc}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* Language Selector */}
                    <div className="mb-4">
                      <div className="flex space-x-2 mb-4">
                        {Object.keys(codeExamples).map((lang) => {
                          const isActive = activeLanguage === lang
                          const buttonClass = isActive
                            ? "bg-green-600 text-white"
                            : "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600"

                          return (
                            <button
                              key={lang}
                              onClick={() => setActiveLanguage(lang)}
                              className={`px-3 py-1 rounded text-sm font-medium ${buttonClass}`}
                            >
                              {lang.charAt(0).toUpperCase() + lang.slice(1)}
                            </button>
                          )
                        })}
                      </div>
                    </div>

                    {/* Code Example */}
                    <div className="relative">
                      <button
                        onClick={() => copyToClipboard(codeExamples[activeLanguage].sendMessage, "sendMessage")}
                        className="absolute top-2 right-2 bg-gray-700 hover:bg-gray-600 text-white px-2 py-1 rounded text-xs flex items-center space-x-1"
                      >
                        {copiedStates.sendMessage ? (
                          <CheckIcon className="w-3 h-3" />
                        ) : (
                          <CopyIcon className="w-3 h-3" />
                        )}
                        <span>{copiedStates.sendMessage ? "Copied!" : "Copy"}</span>
                      </button>
                      <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
                        {codeExamples[activeLanguage].sendMessage}
                      </pre>
                    </div>
                  </div>
                </div>
              )}

              {/* Campaigns Tab */}
              {activeTab === "campaigns" && (
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Campaign Management</h2>

                  <div className="space-y-8">
                    {/* Create Campaign */}
                    <div>
                      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-4">
                        <h3 className="font-semibold text-blue-800 dark:text-blue-300 mb-2">Create Campaign</h3>
                        <code className="text-sm bg-white dark:bg-gray-800 px-2 py-1 rounded">
                          POST /api/campaigns/api/create
                        </code>
                      </div>

                      <div className="relative mb-4">
                        <button
                          onClick={() => copyToClipboard(codeExamples[activeLanguage].createCampaign, "createCampaign")}
                          className="absolute top-2 right-2 bg-gray-700 hover:bg-gray-600 text-white px-2 py-1 rounded text-xs flex items-center space-x-1"
                        >
                          {copiedStates.createCampaign ? (
                            <CheckIcon className="w-3 h-3" />
                          ) : (
                            <CopyIcon className="w-3 h-3" />
                          )}
                          <span>{copiedStates.createCampaign ? "Copied!" : "Copy"}</span>
                        </button>
                        <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
                          {codeExamples[activeLanguage].createCampaign}
                        </pre>
                      </div>
                    </div>

                    {/* Send Campaign */}
                    <div>
                      <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-4 mb-4">
                        <h3 className="font-semibold text-purple-800 dark:text-purple-300 mb-2">Send Campaign</h3>
                        <code className="text-sm bg-white dark:bg-gray-800 px-2 py-1 rounded">
                          POST /api/campaigns/api/:campaignId/send
                        </code>
                      </div>

                      <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                        <h4 className="font-medium text-gray-900 dark:text-white mb-2">Example Request</h4>
                        <pre className="bg-gray-900 text-green-400 p-3 rounded text-sm overflow-x-auto">
                          {`curl -X POST "https://your-api-domain.com/api/campaigns/api/CAMPAIGN_ID/send" \\
  -H "X-API-Key: ${apiKey || "your-api-key"}" \\
  -H "Content-Type: application/json"`}
                        </pre>
                      </div>
                    </div>

                    {/* Campaign Status */}
                    <div>
                      <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4 mb-4">
                        <h3 className="font-semibold text-orange-800 dark:text-orange-300 mb-2">Get Campaign Status</h3>
                        <code className="text-sm bg-white dark:bg-gray-800 px-2 py-1 rounded">
                          GET /api/campaigns/:campaignId/status
                        </code>
                      </div>

                      <div className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
                        <h4 className="font-medium text-gray-900 dark:text-white mb-2">Response Example</h4>
                        <pre className="bg-gray-900 text-green-400 p-3 rounded text-sm overflow-x-auto">
                          {`{
  "success": true,
  "campaign": {
    "id": "campaign_id",
    "status": "completed",
    "totalMessages": 1000,
    "sentMessages": 950,
    "failedMessages": 50,
    "startedAt": "2024-01-15T10:00:00Z",
    "completedAt": "2024-01-15T10:30:00Z"
  }
}`}
                        </pre>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Error Codes Tab */}
              {activeTab === "errors" && (
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Error Codes</h2>
                  <p className="text-gray-600 dark:text-gray-400 mb-6">
                    Common error codes you might encounter when using the API and how to resolve them.
                  </p>

                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                      <thead className="bg-gray-50 dark:bg-gray-700">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                            Error Code
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                            HTTP Status
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                            Description
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                            Solution
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                        {errorCodes.map((error) => {
                          let statusClass = "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
                          if (error.status >= 500) {
                            statusClass = "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200"
                          } else if (error.status >= 400) {
                            statusClass = "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200"
                          }

                          return (
                            <tr key={error.code} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                              <td className="px-6 py-4 whitespace-nowrap">
                                <code className="text-sm font-mono bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200 px-2 py-1 rounded">
                                  {error.code}
                                </code>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className={`px-2 py-1 rounded-full text-xs font-semibold ${statusClass}`}>
                                  {error.status}
                                </span>
                              </td>
                              <td className="px-6 py-4 text-sm text-gray-900 dark:text-white">{error.description}</td>
                              <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">{error.solution}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-8 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
                    <h3 className="font-semibold text-blue-800 dark:text-blue-300 mb-2">💡 Need Help?</h3>
                    <p className="text-blue-700 dark:text-blue-300 text-sm">
                      If you encounter an error not listed here or need additional support, please contact our technical
                      support team with the error details and your API request information.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Apikey
